import { Column, div, Flex, Loading } from "lqx-react";
import React from "react";
import WarningIcon from '@material-ui/icons/Warning';
import CheckIcon from '@material-ui/icons/Check';
import { AssetEvent } from "../api/assetEvent";
import { DigiTooltip } from "../shared";
import { ExternalSystem } from "../api/externalSystemRequest";
import { styled } from "@material-ui/core";

export const InblockedAssetEventStatusItem = ({ assetEvent, externalSystem, externalSystemsDictionary }: {
    assetEvent: AssetEvent,
    externalSystem: ExternalSystem,
    externalSystemsDictionary: any
}) => {

    return <ExternalSystemColumn key={externalSystem.assetEventType}>
        {
            assetEvent &&
            <>
                {assetEvent.isPending &&
                    <DigiTooltip key={assetEvent.eventTypeId} title={
                        <>
                            {<Flex row key={assetEvent.id}>{externalSystemsDictionary[ assetEvent.eventTypeId ].waitingMessage}.</Flex>}
                        </>
                    }>
                        <LoadingContainer key={assetEvent.eventTypeId}>
                            <Loading />
                        </LoadingContainer>
                    </DigiTooltip>
                }
                {assetEvent.hasSucceeded &&
                    <DigiTooltip key={assetEvent.eventTypeId} title={
                        <span>{externalSystemsDictionary[ assetEvent.eventTypeId ].successMessage}. {assetEvent.message}</span>
                    }>
                        <Success><CheckIcon /></Success>
                    </DigiTooltip>
                }
                {assetEvent.hasFailed &&
                    <DigiTooltip key={assetEvent.eventTypeId} title={
                        <span>{externalSystemsDictionary[ assetEvent.eventTypeId ].failMessage}. {assetEvent.message}</span>
                    }>
                        <Warning><WarningIcon /></Warning>
                    </DigiTooltip>
                }
            </>
        }
    </ExternalSystemColumn>
}

const LoadingContainer = div({
    marginTop: '3px',
    marginLeft: '5px',
    maxWidth: '20px',
    maxHeight: '20px',
    '& .MuiCircularProgress-root': {
        maxWidth: '20px',
        maxHeight: '20px',
    }
});

const Warning = div({
    color: '#eabc5e'
});

const Success = div({
    color: '#4197d6'
});

const ExternalSystemColumn = styled(Column)({
    maxWidth: '25px',
    margin: 0,
    padding: '2px'
});
